import * as React from 'react';
import { Link } from 'react-router-dom';

import PeopleIcon from '@mui/icons-material/People';

import { ISiteCardProps } from 'src/features/site/domain/types';

export const SiteCard: React.FC<ISiteCardProps> = ({
	siteName,
	patientCount,
	lastUpdated,
	siteSlug,
}) => {
	return (
		<Link to={`/site/${siteSlug}`} className='no-underline'>
			<article className='flex flex-col p-4 bg-white rounded-md border border-solid border-[rgba(98, 94, 94, 0.38)] w-full max-w-full shadow-[0px_4px_4px_rgba(0,0,0,0.25)] hover:shadow-lg transition-shadow duration-200'>
				<div className='flex flex-col w-full'>
					<h3 className='text-base tracking-wide leading-none text-black text-left mt-[3px]'>
						{siteName}
					</h3>
					<div className='flex gap-1.5 items-center self-start mt-2.5 text-sm tracking-normal leading-none text-black text-opacity-60'>
						<PeopleIcon className='w-5 h-5' />
						<p className='self-stretch my-auto'>
							{patientCount} Patients
						</p>
					</div>
				</div>
				<time className='self-start mt-6 text-xs tracking-normal leading-none text-black text-opacity-60 min-h-[21px]'>
					{lastUpdated}
				</time>
			</article>
		</Link>
	);
};

export default SiteCard;
